<div
  [ngClass]="{
    'on-screen': onScreen === true,
    'ticker-search-icon--active': hasSearchIcon
  }"
  class="ticker-search-wrapper"
>
  <div *ngIf="hasSearchIcon" class="ticker-search-icon">
    <va-icon
      size="small"
      name="search"
      class="fal fa-md"
      style="color: #979797"
    ></va-icon>
  </div>
  <div [ngClass]="{ 'on-screen-search': onScreen === true }">
    <nz-select
      nzShowSearch
      nzServerSearch
      nzAllowClear
      [nzPlaceHolder]="placeholder"
      [(ngModel)]="selectedTicker"
      (ngModelChange)="onChangeTicker($event)"
      [nzDropdownRender]="onScreen === true ? renderTemplate : null"
      [nzDropdownClassName]="
        onScreen
          ? ['on-screen-ticker', 'ticker-search-dropdown']
          : 'ticker-search-dropdown'
      "
      [nzShowArrow]="false"
      [nzNotFoundContent]="noContentTemplate"
      (nzOnSearch)="searchTicker($event)"
      [nzDisabled]="disabled"
      [nzDropdownMatchSelectWidth]="false"
    >
      <ng-container
        *ngIf="suggestedTickers && onScreen === true; else searchBlock"
      >
        <nz-option-group
          [nzLabel]="
            !queryString
              ? suggestedTickers.length
                ? 'Suggestions:'
                : 'No Suggestions Found.'
              : searchResult.length
                ? 'Showing Results:'
                : 'No Results Found.'
          "
        >
          <!-- <ng-container *ngFor="let o of searchResult; index as i"> -->
          <nz-option
            nzCustomContent
            *ngFor="let r of !queryString ? suggestedTickers : searchResult"
            [nzLabel]="r.full_name || r.name + ' (' + r.ticker + ')'"
            [nzValue]="r"
            [nzDisabled]="
              maxSelectedTickerCount && tickers.length >= maxSelectedTickerCount
            "
            [ngClass]="{
              'select-footer-highlight':
                maxSelectedTickerCount &&
                tickers.length >= maxSelectedTickerCount
            }"
          >
            <span
              [innerHtml]="
                r.full_name || r.name + ' (' + r.ticker + ')'
                  | textHighlight: queryString
              "
            ></span>
          </nz-option>
          <!-- </ng-container> -->
        </nz-option-group>
      </ng-container>

      <ng-template #searchBlock>
        <nz-option
          nzCustomContent
          *ngFor="let r of searchResult"
          [nzLabel]="
            r.full_name + ' (' + isTickerTypeBg ? r.bTicker : r.ticker + ')'
          "
          [nzValue]="r"
        >
          <span
            [innerHtml]="
              isTickerTypeBg
                ? (r.full_name + ' (' + r.bTicker + ')'
                  | textHighlight: queryString)
                : (r.full_name + ' (' + r.ticker + ')'
                  | textHighlight: queryString)
            "
          ></span>
        </nz-option>
      </ng-template>

      <ng-template #noContentTemplate>
        <span
          class="no-content-item"
          *ngIf="onScreen && !queryString && !suggestedTickers.length"
          >No Suggestions Found.</span
        >
        <span
          class="no-content-item"
          *ngIf="
            isTickerSearchApiDataReady && queryString && !searchResult.length
          "
          >No Results Found.</span
        >
      </ng-template>
    </nz-select>
    <ng-template #renderTemplate>
      <div
        class="select-footer"
        *ngIf="maxSelectedTickerCount"
        [ngClass]="{
          'select-footer-highlight': tickers.length >= maxSelectedTickerCount
        }"
      >
        Selected Companies {{ tickers.length }}/{{ maxSelectedTickerCount }}
      </div>
    </ng-template>
  </div>
  <!-- <div>
      <button  class="button">Edit</button>
    </div>  -->
</div>
